import { useStoreActions } from '~/contexts';
import { QueryKeys } from '~/hooks/reactQuery/queryKeys';
import { useQueryState } from '~/hooks/reactQuery/useQueryState';
import { useFeatureFlags } from '~/hooks/useFeatureFlags';
export const useInvoiceDashboardPreferences = function useInvoiceDashboardPreferences() {
    let { enabled = true } = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    const { api } = useStoreActions();
    const { INVOICE_DASHBOARD_METRICS } = useFeatureFlags();
    const { data, isLoading, error, refresh } = useQueryState({
        queryKey: [
            QueryKeys.InvoiceDashboardPreferences
        ],
        queryFn: ()=>api.invoice.getDashboardPreferences(),
        enabled: enabled && INVOICE_DASHBOARD_METRICS
    });
    return {
        preferences: data,
        isLoading,
        error,
        refresh
    };
};
